const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const readMessage = (value: unknown): string | undefined => {
  if (!isRecord(value)) return undefined;
  return typeof value.message === 'string' ? value.message : undefined;
};

export const getErrorMessage = (error: unknown, fallback: string): string => {
  const directMessage = readMessage(error);
  if (directMessage) return directMessage;

  if (isRecord(error)) {
    const response = error.response;
    if (isRecord(response)) {
      const responseMessage = readMessage(response.data);
      if (responseMessage) return responseMessage;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallback;
};

export const isAbortError = (error: unknown): boolean => {
  if (error instanceof DOMException) return error.name === 'AbortError';
  if (error instanceof Error) {
    const message = error.message.toLowerCase();
    if (error.name === 'AbortError' || message.includes('abort') || message.includes('signal is aborted')) return true;
  }
  if (!isRecord(error)) return false;
  if (error.name === 'AbortError') return true;
  const message = typeof error.message === 'string' ? error.message.toLowerCase() : '';
  if (message.includes('abort') || message.includes('signal is aborted')) return true;
  return isAbortError(error.causeError) || isAbortError(error.cause);
};
